<template>
  <div v-if="!loading" style="width: 100%; max-width: 740px;">
    <b-dropdown
      v-if="whiteGloveMissionControlAdminUi && auditsDropdownItems.length && auditsDropdownItems.length > 1"
      aria-role="list"
      class="mb-4"
    >
      <template #trigger>
        <b-button
          icon-right="angle-down">
          Showing: <span class="font-weight-bold">{{auditsDropdownItems?.filter(item => item.key === activeAuditId)?.[0]?.label || '-'}}</span>
        </b-button>
      </template>
      <b-dropdown-item v-for="item in auditsDropdownItems" :key="item.key" @click="activeAuditId = item.key">{{ item.label }}</b-dropdown-item>
    </b-dropdown>
    <single-audit-view
      :key="activeAudit?.id"
      :showOrderNewAuditButton="activeAudit.id && (activeAudit.id === audits[0].id)"
      :site="site"
      :activeAudit="activeAudit"
      :contentAuditPackages="contentAuditPackages"
      :loadData="loadData"
      @auditUpdated="audits = audits.map(audit => audit.id === $event.id ? $event : audit)"
    />
  </div>
</template>

<script>
import SingleAuditView from './SingleAuditView.vue'


export default {
  components: { SingleAuditView },
  props: ['site'],
  data () {
    return {
      loading: true,
      audits: [],
      activeAuditId: null,
      contentAuditPackages: null,
    }
  },
  computed: {
    user () {
      if (this.$store.state.user) {
        return this.$store.state.user
      }
      return null
    },
    selectedSubAccountRelation () {
      return this.$store.state.selectedSubAccountRelation
    },
    isMissionControlSession () {
      return Boolean(this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount)
    },
    isWhiteGloveAdminMode () {
      return this.$store.state.isWhiteGloveAdminMode
    },
    whiteGloveMissionControlAdminUi () {
      return this.isMissionControlSession && this.isWhiteGloveAdminMode
    },
    activeAudit () {
      if (this.activeAuditId) {
        return this.audits.filter(audit => audit.id === this.activeAuditId)?.[0]
      }
      return null
    },
    auditsDropdownItems () {
      return [
        ...this.audits.map((audit) => ({
          key: audit.id,
          label: audit?.order_status === 'user_editing' ? 'New audit' : `Audit ${audit.id}`
        }))
      ]
    }
  },
  watch: {
    'site.id': {
      handler: function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.loadData(true)
        }
      },
      immediate: true,
    },
    '$store.state.refreshDataAfterCartPurchase': function () {
      this.loadData();
    }
  },
  methods: {
    loadData (resetActiveAuditId = false) {
      return this.$store.dispatch('getSiteContentAudits', {
        siteId: this.site.id,
      })
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            this.audits = response.data.data
            if (resetActiveAuditId) {
              const lastAudit = this.audits?.[0]
              this.activeAuditId = lastAudit?.id
            } else {
              // Not the initial load: an audit changed (purchase, form, GSC, admin action).
              // Hosts that show project statuses (POP Authority layout) re-fetch on this.
              this.$emit('audits-changed', this.audits)
            }
            return Promise.resolve()
          }
        })
        .then(() => {
          return this.$store.dispatch('getAvailableWhiteGloveAddonPackages')
            .then(response => {
              if (response.data && response.data.status == 'SUCCESS') {
                this.contentAuditPackages = Object.fromEntries(
                  response.data.packages
                    .filter(p => ["WHITE_GLOVE_ADDON_CONTENT_AUDIT", "WHITE_GLOVE_ADDON_CONTENT_AUDIT_SPEEDY_DELIVERY", "POP_AUTHORITY_SETUP_FEE"].includes(p.key))
                    .map(p => [p.key, p])
                );
                return Promise.resolve()
              }
            })
        })
        .finally(() => {
          this.loading = false;
        })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
